import { DataResult, State } from "@progress/kendo-data-query";
import {
  Grid,
  GridCellProps,
  GridColumnReorderEvent,
  GridContextMenuEvent,
  GridDataStateChangeEvent,
  GridDetailRowProps,
  GridEvent,
  GridExpandChangeEvent,
  GridRowClickEvent,
  GridRowProps,
  GridSortChangeEvent,
} from "@progress/kendo-react-grid";
import React, { cloneElement, useCallback } from "react";
import sizeConfigs from "../../configs/sizeConfigs";

interface CustomGridProps {
  data: any[] | DataResult | null;
  pageSize?: number;
  detail?: React.ComponentType<GridDetailRowProps> | null | undefined;
  expandChange?: ((event: GridExpandChangeEvent) => void) | undefined;
  dataStateChange?: ((event: GridDataStateChangeEvent) => void) | undefined;
  handleSort?: ((event: GridSortChangeEvent) => void) | undefined;
  scrollHandler?: ((event: GridEvent) => void) | undefined;
  onContextMenu: ((event: GridContextMenuEvent) => void) | undefined;
  handleClick: ((event: GridRowClickEvent) => void) | undefined;
  handleColumnReorder: ((event: GridColumnReorderEvent) => void) | undefined;
  dataState: State;
  toolbar?: any;
  rows: any;
  id: string;
  isPlanoGroupe?: boolean;
}

export default function CustomGrid(props: CustomGridProps) {
  const rowRender = useCallback(
    (row: any, gridRowProps: GridRowProps) => {
      const background =
        props.isPlanoGroupe && gridRowProps.dataItem.field_highlight
          ? { style: { backgroundColor: "yellow" } }
          : {};
      const rowProps = {
        ...row.props,
        id: gridRowProps.dataItem[props.id],
        ...background,
      };
      return React.cloneElement(row, { ...rowProps }, row.props.children);
    },
    [props.id, props.isPlanoGroupe]
  );

  const cellRender = (
    tdElement: React.ReactElement<HTMLTableCellElement> | null,
    cellProps: GridCellProps
  ) => {

    const { dataItem, field, rowType, columnIndex } = cellProps;

    if (dataItem && field && rowType === "data" && tdElement) {

      const isHighlighted: boolean =
        (dataItem.field_highlight ?? "")
          .toUpperCase()
          .split(",")
          .includes(field.toUpperCase()) || false;

      const appliedStyle = (isHighlighted)
        ? { color: "red" }
        : {};

      const clonedTdElementProps = {
        ...tdElement.props,
        style: { ...tdElement.props.style, ...appliedStyle },
        "aria-colindex": columnIndex,
        "role": "gridcell",
      };

      return cloneElement(tdElement, clonedTdElementProps);
    }

    return tdElement
  };

  return (
    <Grid
      data={props.data}
      {...props.dataState}
      onRowClick={props.handleClick}
      pageSize={props.pageSize}
      onScroll={props.scrollHandler}
      onContextMenu={props.onContextMenu}
      sortable={{
        allowUnsort: true,
      }}
      onSortChange={props.handleSort}
      fixedScroll={true}
      groupable={true}
      reorderable={true}
      detail={props.detail}
      onExpandChange={props.expandChange}
      onDataStateChange={props.dataStateChange}
      expandField="expanded"
      selectedField="selected"
      resizable
      style={{
        width: "100%",
        height: `calc(100vh - ${sizeConfigs.topbar.height} - ${sizeConfigs.footer.height})`,
      }}
      id="main-grid"
      cellRender={cellRender}
      rowRender={rowRender}
      onColumnReorder={props.handleColumnReorder}
    >
      {props.toolbar}
      {props.rows}
    </Grid>
  );
}